<template>
  <modal
    name="worksModal"
    :click-to-close="false"
    :width="645"
    :height="506"
    @before-open="beforeOpen"
  >
    <works-content
      ref="content"
      v-bind="callbacks"
    ></works-content>
  </modal>
</template>

<script>
import WorksContent from './worksContent';
import modalMixin from './modalMixin.js';
export default {
  components: {
    WorksContent
  },
  mixins: [modalMixin],
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
